import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import './location-benefits.scss'
import { Fade } from 'react-reveal'
import useFetch from '../../../Hooks/useFetch'
import {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
} from '../../../assets/img/LB-icons'

export default function LocationBenefits({ projectNumber }) {
  const { data } = useFetch()
  // console.log(baseUrl + data?.[0].Locationbenefit.Benefitfeatures[0].icon.url)
  return (
    <div id='location-benefits'>
      <Container>
        <Row>
          {/* heading */}
          <Col md={12} className='text-center header-div'>
            <h2>{projectNumber?.fields.lbTitle}</h2>
          </Col>
          {/* cards */}
          <Fade bottom cascade>
            <div className='row'>
              {projectNumber?.fields.benefitfeature.map((el, i) => (
                <Col lg={3} sm={6}>
                  <div className='icons-desc'>
                    <p className='icons-txtpara'>
                      <img src={el.icon} alt='wd' width='64' height='64' />
                    </p>
                    <p className='icons-txtpara'>{el.distance}</p>
                    <p className='icons-txtpara'>{el.place}</p>
                  </div>
                </Col>
              ))}{' '}
            </div>
          </Fade>
        </Row>
      </Container>
    </div>
  )
}

const locationData = [
  {
    alt: 'wd',
    img: img1,
    title: '5 MINS',
    desc: 'Drive from Mc Donalds/Green Valley and other famous places',
  },
  {
    alt: 'wd',
    img: img2,
    title: '5 MINS',
    desc: 'Drive to Kallisto Multi level restaurant',
  },
  {
    alt: 'wd',
    img: img3,
    title: '1 MINS',
    desc: 'Drive to new head office',
  },
  {
    alt: 'wd',
    img: img4,
    title: 'Next to',
    desc: 'Future world school',
  },
  {
    alt: 'wd',
    img: img5,
    title: 'Easy Approach',
    desc: 'From every sector',
  },
  {
    alt: 'wd',
    img: img6,
    title: '3 MINS',
    desc: 'drive to Malik Riaz Masjid',
  },
  {
    alt: 'wd',
    img: img7,
    title: '10 MINS',
    desc: 'drive to GT Road ',
  },
  {
    alt: 'wd',
    img: img8,
    title: '5 MINS',
    desc: 'drive to Bahria International hospital',
  },
]
